export const CLIPBOARD_FEEDBACK_EVENT = "stc:clipboard-feedback";

export interface ClipboardFeedbackDetail {
  message: string;
  tone: "success" | "error";
}

function announceClipboardFeedback(detail: ClipboardFeedbackDetail): void {
  window.dispatchEvent(new CustomEvent<ClipboardFeedbackDetail>(CLIPBOARD_FEEDBACK_EVENT, { detail }));
}

export async function copyText(value: string, message = "COPIED TO CLIPBOARD"): Promise<boolean> {
  try {
    if (!navigator.clipboard?.writeText) throw new Error("Clipboard access is unavailable");
    await navigator.clipboard.writeText(value);
    announceClipboardFeedback({ message, tone: "success" });
    return true;
  } catch {
    announceClipboardFeedback({ message: "COPY FAILED", tone: "error" });
    return false;
  }
}
